import React from "react";
import ReactDOM from "react-dom";
import 'antd/dist/antd.css';
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./utils/i18n";
import configureStore, { AppState } from "./redux/store";
import { AnyAction, Store } from "redux";
import { Provider } from "react-redux";

type NewType = Store<AppState, AnyAction>;

interface Props {
  store: NewType;
}

const Root: React.FunctionComponent<Props> = (props: Props) => {
  return (

    <Provider store={props.store}>
      <App />
    </Provider>
  );
};

// Generate the store
const store = configureStore();

// Render the App
ReactDOM.render(
  <Root store={store} />,
  document.getElementById(
    'root'
  ));


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
